import { createContext } from 'react';

const SelectableContext = createContext({
    selection: [],
    lastSelectedNumber: null,
    isSelecting: false
})

export default SelectableContext;